import {takeLatest} from '@redux-saga/core/effects';
import {Async, Empty, Loading} from 'Core/models/Async';
import {NonEmptyString} from 'Core/models/EmptyString';
import {createAction} from 'Shared/utilities/actionCreator';
import {apiCallGenerator, getApiCallGenerator} from 'Shared/utilities/sagaApiGenerators';
import {Agent} from 'http';
import agentApi from 'Users/api/agentApi';
import {AgentUser} from 'Users/models/AgentUser';

enum AgentSignUpActionType {
  FETCH_AGENT_USER = 'agentSignUp/FETCH',
  CHANGE_AGENT_USER = 'agentSignUp/CHANGE_AGENT_USER',
  UPDATE_USERNAME = 'agentSignUp/UPDATE_USERNAME',
}

export const updateUsername = (key: string, username: NonEmptyString, changeRegistration: (agent: Agent) => void) =>
  createAction(AgentSignUpActionType.UPDATE_USERNAME, {
    key,
    username,
    changeAsyncData: changeRegistration,
  });
export const fetchAgentUser = (key: string) => createAction(AgentSignUpActionType.FETCH_AGENT_USER, {key});
export const changeAgentUser = (agent: Async<AgentUser>) =>
  createAction(AgentSignUpActionType.CHANGE_AGENT_USER, agent);

type AgentSignUpState = {
  agent: Async<AgentUser>;
  username: string;
};

export const DEFAULT_STATE: AgentSignUpState = {
  agent: new Empty(),
  username: '',
};

type AgentSignUpAction = ReturnType<typeof fetchAgentUser> | ReturnType<typeof changeAgentUser>;

export default (state: AgentSignUpState = DEFAULT_STATE, action: AgentSignUpAction): AgentSignUpState => {
  switch (action.type) {
    case AgentSignUpActionType.FETCH_AGENT_USER:
      return {
        ...state,
        agent: new Loading(),
      };
    case AgentSignUpActionType.CHANGE_AGENT_USER:
      return {
        ...state,
        agent: action.payload,
      };
    default:
      return state;
  }
};

export const getAgentUser = (action: ReturnType<typeof fetchAgentUser>) => {
  const {key} = action.payload;

  return agentApi.getAgentByEmail(key);
};

export function* watchFetchAgentUser() {
  yield takeLatest(AgentSignUpActionType.FETCH_AGENT_USER, getApiCallGenerator(getAgentUser, changeAgentUser));
}

export const updateRegistrationUsername = (action: ReturnType<typeof updateUsername>) => {
  const {key, username} = action.payload;

  return agentApi.updateAgentUsername(key, username);
};

export function* watchUpdateRegistrationUsername() {
  yield takeLatest(AgentSignUpActionType.UPDATE_USERNAME, apiCallGenerator(updateRegistrationUsername));
}
